import React, { useMemo } from 'react';
import ActionsContainer from './components/ActionsContainer';
import BackButton from './components/BackButton';
import Bar from './components/Bar';
import Container from './components/Container';
import Counter from './components/Counter';
import SaveButton from './components/SaveButton';
import { ProgressBarContext } from './context';
/**
 * The ProgressBar component is a container for the progress bar and its counter.
 * It also contains the actions container, which is used to display the back and save buttons.
 */
const ProgressBar = ({ children, type = 'square', ...rest }) => {
    const contextValue = useMemo(() => ({
        type,
        ...rest,
    }), [rest]);
    return (React.createElement(ProgressBarContext.Provider, { value: contextValue }, children));
};
/**
 * Flex container component for the progress bar and its counter.
 */
ProgressBar.Container = Container;
/**
 * Bar component for the progress bar.
 */
ProgressBar.Bar = Bar;
/**
 * Counter component for the progress bar. Use `ProgressBar.Container` to
 * wrap the bar and this counter.
 */
ProgressBar.Counter = Counter;
/**
 * Flex container component for the progress bar actions, ideally shown on top of the bar (and its counter).
 */
ProgressBar.ActionsContainer = ActionsContainer;
/**
 * Back button component for the progress bar actions. Use `ProgressBar.ActionsContainer` to wrap the back button.
 */
ProgressBar.BackButton = BackButton;
/**
 * Save button component for the progress bar actions. Use `ProgressBar.ActionsContainer` to wrap the save button.
 */
ProgressBar.SaveButton = SaveButton;
export default ProgressBar;
